import type { RubricScore } from "@/lib/types"

/** The five things every interview answer is scored on, 0–5 each. */
export const DIMENSIONS: { key: keyof RubricScore; label: string; hint: string }[] = [
  { key: "structure", label: "Structure", hint: "Situation, task, action, result - in that order" },
  { key: "specificity", label: "Specificity", hint: "Names, numbers, tools; not generalities" },
  { key: "ownership", label: "Ownership", hint: "What you did, not what the team did" },
  { key: "impact", label: "Impact", hint: "What changed, measured where possible" },
  { key: "relevance", label: "Relevance", hint: "Actually answers the question asked" },
]

export const MAX_SCORE = 5
